export const GRADES_TITLE = 'Grades'
export const ALL_GRADES_ID = 'all'
